import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import {Project} from '../../../projects/models/project';
import {Comment} from '../../../projects/models/comment';

@Component({
  selector: 'app-view-comments',
  templateUrl: './view-comments.component.html',
  styleUrls: ['./view-comments.component.css']
})
export class ViewCommentsComponent implements OnInit {

  comments: Comment[];
  project: Project;
  partner: any;

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {}
}
